/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useAvailabilityInfoData } from '@/features/orders/api/getAvailabilityInfo';
import { useFeatureFlag } from '@/features/globalConfig';
import { useIsStoreSelected } from '@/features/header/hooks/useIsStoreSelected';
import { useForteDecisionFlagWithTrueDefault } from '@/features/forte/api/getForteDecision';

export const useShowDealsDrawerButton = ({
  skuId,
  flag,
  fulfillmentID,
  discounted,
}: {
  skuId: string | null;
  fulfillmentID: number;
  flag:
    | 'dealBadgeEnabled'
    | 'enableInternationalPayments'
    | 'isOrderSummaryRedesignEnabled'
    | 'checkoutOrderSummaryV2Enabled'
    | 'isLoqateZipcodeValidationEnabled'
    | 'useGCPPriceService';
  discounted: boolean;
}) => {
  const isStoreSelected = useIsStoreSelected();
  const { data: availabilityInfo } = useAvailabilityInfoData();
  const itemAvailability = availabilityInfo?.itemAvailability;
  const availabilityInfoItem = itemAvailability?.find((e) => e.skuId === skuId);
  const selectedFulfillmentGroup = availabilityInfoItem?.fulfillmentGroups.find((g) => g.selected);
  const selectedGroupFulfillmentOption = selectedFulfillmentGroup?.groupFulfillmentOptions?.find(
    (o) => o.selected,
  );

  const isDealBadgeEnabled = useForteDecisionFlagWithTrueDefault(flag);
  const strikeThroughPricingFlag = useFeatureFlag('SHOW_STRIKE_THROUGH_PRICING') === 'true';
  const showStrikeThroughPricing = strikeThroughPricingFlag && discounted;
  const shouldShowDealsButton: boolean =
    !!availabilityInfoItem &&
    !!selectedFulfillmentGroup &&
    !!selectedGroupFulfillmentOption &&
    !!fulfillmentID &&
    !!isDealBadgeEnabled &&
    selectedGroupFulfillmentOption.fulfillmentTypeId === fulfillmentID &&
    selectedGroupFulfillmentOption.availableQty > 0 &&
    selectedGroupFulfillmentOption.dealsAvailableQty > 0 &&
    isStoreSelected &&
    !showStrikeThroughPricing;

  return { shouldShowDealsButton };
};
